module.exports = __webpack_public_path__ + "static/media/light-switch-off.70af8a47.svg";